/* v8 ignore file -- @preserve */
import { defineStore } from 'pinia';
import { SET_REGISTRIES } from '#shared/types/actions';
import { formatDateMcom, formatDateBcom } from '#shared/utils/formatDate';

export const useNavRegistry = defineStore('navRegistry', {
  state: () => ({
    registries: [],
    allowedOccasions: '',
  }),
  getters: {
    hasRegestries(state) {
      return !!state.registries.length;
    },
    occasionsMap(state) {
      return state.registries.reduce((acc, cur) => {
        const { occasionType } = cur;
        const prevValue = acc[occasionType];
        const newValue = prevValue ? prevValue + 1 : 1;

        return {
          ...acc,
          [occasionType]: newValue,
        };
      }, {});
    },
    occasions(state) {
      const occasionsMap = this.occasionsMap;
      const envProps = useEnvProps();

      return state.registries.reduce((acc, cur) => {
        const { occasionType, occasionDate, registryId, registryGUID } = cur;
        const date = envProps.isMcom ? formatDateMcom(occasionDate) : formatDateBcom(occasionDate);
        const text = occasionsMap[occasionType] > 1 || envProps.isBcom ? `${occasionType} ${date}` : occasionType;

        return acc.concat({ text, registryId, registryGUID });
      }, []);
    },
    getAllowedOccasions(state) {
      return state.allowedOccasions
        .toLowerCase()
        .split(',')
        .map((el) => el.trim());
    },
  },
  actions: {
    [SET_REGISTRIES](payload = {}) {
      const { registries = [], allowedOccasions = '' } = payload;
      this.registries = registries;
      this.allowedOccasions = allowedOccasions;
    },
  },
});
